export default {
  async createDeveloperToken(name, expiresInDays = 90, groupId = null) {
    const body = { name, expires_in_days: expiresInDays };
    if (groupId) body.group_id = groupId;
    return this.request('/developer-tokens', {
      method: 'POST',
      body,
    });
  },

  async listDeveloperTokens() {
    return this.request('/developer-tokens');
  },

  async revokeDeveloperToken(tokenId) {
    return this.request(`/developer-tokens/${tokenId}`, {
      method: 'DELETE',
    });
  },
};
